import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import { closeModal } from 'store/modals/actions';
import { MODAL_AGENT_DETAIL } from 'store/modals/modals';
import { selectTriggerAgent } from 'store/Agents/selectors';
import { Status } from '../../../../../Grid/components/UserAgents/components/UserAgent/styled';
import { Wrapper, Top, AgentIcon, Name, Left, Description } from './styled';
import BlueButton from 'Common/Components/BlueButton';
import { CloseIconWrapper, CloseIcon } from 'Screens/Contextualization/Host/components/HostDetail/components/Header/styled';
import { saveAgentToolData } from 'store/Agents/actions';

const Header = ({ toolExpanded }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const agent = useSelector(selectTriggerAgent);
  const name = get(agent, 'name', '');
  const statusValue = get(agent, 'status', '');
  const statusLabel = statusValue ? intl.formatMessage({ id: `agents.item.status.${statusValue}` }) : 'Online';
  const description = get(agent, 'description', '');
  const parameters_data = get(agent, 'toolSelected.parameters_data', {});

  const closeDetail = () => dispatch(closeModal(MODAL_AGENT_DETAIL));

  const saveData = () => {
    if (toolExpanded) {
      dispatch(saveAgentToolData(toolExpanded, parameters_data));
    }
  };

  return (
    <Wrapper>
      <Top>
        <Left>
          <AgentIcon />
          <Name>{ name }</Name>
          <Status children={ statusLabel } value={ statusValue } noMargin />
        </Left>
          <BlueButton onClick={ saveData } label="Save" />
          <CloseIconWrapper onClick={ closeDetail }>
            <CloseIcon />
          </CloseIconWrapper>
      </Top>
      <Description children={ description } />
    </Wrapper>
  );
};

export default Header;
